import { nullSafe, truncateString } from 'Utility/globalMethods';

/*
 * This middleware captures actions to push gmt event
 */

let alwaysPresentParams = '';
export const setMenuAnalytics = (label, target_url, level) => {
  window.dataLayer.push({
    event: 'menu_click',
    menu: {
      clicked: {
        first_level: {
          label: level === 1 ? label : null,
          target_url: level === 1 ? target_url : null
        },
        second_level: {
          label: level === 2 ? label : null,
          target_url: level === 2 ? target_url : null
        },
        third_level: {
          label: level === 3 ? label : null,
          target_url: level === 3 ? target_url : null
        }
      }
    },
    ...alwaysPresentParams
  });
};
export const setCtaAnalytics = (text, ctaClass, target_url, id) => {
  window.dataLayer.push({
    event: 'cta_click',
    cta: {
      text: text || null,
      class: ctaClass || null,
      target_url: target_url || null,
      id: id || null
    },
    ...alwaysPresentParams
  });
};
export const setTabSwitchingAnalytics = label => {
  window.dataLayer.push({
    event: 'tab_switching',
    tab: {
      label: label || null
    },
    ...alwaysPresentParams
  });
};
export const setPopupClickAnalytics = (title, description, primaryAction, secondaryAction, clicked) => {
  window.dataLayer.push({
    event: 'popup',
    popup: {
      action: clicked ? 'click' : 'impression',
      elements: {
        title: truncateString(typeof title === 'object' ? nullSafe(() => title.props.defaultMessage, null) : title, 100),
        content: truncateString(typeof description === 'object' ? nullSafe(() => description.props.defaultMessage, null) : description || null, 100),
        name: null,
        cta: {
          existing: primaryAction || secondaryAction ? [...[typeof primaryAction === 'object' ? nullSafe(() => primaryAction.props.defaultMessage, null) : primaryAction].filter(Boolean), ...[typeof secondaryAction === 'object' ? nullSafe(() => secondaryAction.props.defaultMessage, null) : secondaryAction].filter(Boolean)] : null,
          clicked: typeof clicked === 'object' ? nullSafe(() => clicked.props.defaultMessage, null) : clicked || null
        }
      }
    },
    ...alwaysPresentParams
  });
};
export const setInputFieldFocusAnalytics = (input_field, action) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'input_field_focus',
    input_field: {
      label: input_field.label || null,
      id: input_field.id || null,
      class: input_field.class || null
    },
    action: action || null,
    ...alwaysPresentParams
  });
};
export const setFormInteraction = (action, id, element = '', result = '', message = '') => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'form_interaction',
    form: {
      action,
      id,
      element,
      send: {
        result,
        message
      }
    }
  });
};
export const setOutcomeAnalytics = (id, description, code, status, message) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'request_outcome',
    request: {
      id,
      description
    },
    response: {
      code,
      status,
      message
    },
    ...alwaysPresentParams
  });
};
export const setCustomErrorAnalytics = (type, code, message, field, isFatal) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'custom_error',
    error: {
      type,
      code,
      message,
      field,
      is_fatal: isFatal
    },
    ...alwaysPresentParams
  });
};
export const analytics = store => next => action => {
  window.dataLayer = window.dataLayer || [];
  const globalState = store.getState();
  alwaysPresentParams = {
    cardholder: {
      id: nullSafe(() => globalState.userProfiling.userInfo.id, null)
    },
    card: {
      abi: nullSafe(() => globalState.userProfiling.cardContext.cardInfo.bankAbi, null),
      affinity: nullSafe(() => globalState.userProfiling.cardContext.cardInfo.affinity, null),
      cpp: nullSafe(() => globalState.userProfiling.cardContext.cardInfo.cpp, null),
      alias: '',
      status: '',
      scheme: nullSafe(() => globalState.userProfiling.cardContext.cardInfo.circuitDetail, null),
      partner: ''
    },
    language: ''
  };
  if (action.type === '@@router/LOCATION_CHANGE') {
    setTimeout(() => {
      // the timeout is necessary to insert the correct title of the page
      window.dataLayer.push({
        event: 'virtual_pageview',
        page: {
          path: nullSafe(() => action.payload.location.pathname, null),
          title: window.document.title
        },
        http: {
          response: {
            code: '301'
          }
        },
        ...alwaysPresentParams
      });
    }, 1000);
  }
  if (/_failure/.test(action.type)) {
    setCustomErrorAnalytics('backend', nullSafe(() => action.error.status, null), nullSafe(() => action.error.type, null), null, false);
  }
  return next(action);
};